import { useSelector } from 'react-redux';

const useDuplicate = (id) => {
  const { deck } = useSelector(state => state.cards)
  
  const found = deck.find(item => item.id === id)

  if (found) {
    return false
  } else {
    return true
  }
}

export default useDuplicate